/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSymbolAsterisk: {
  name: 'symbol-asterisk';
  data: string;
} = {
  name: 'symbol-asterisk',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v2.566l2.223-1.482a.5.5 0 0 1 .554.832L8.901 8l2.376 1.584a.5.5 0 1 1-.554.832L8.5 8.934V11.5a.5.5 0 0 1-1 0V8.934l-2.223 1.482a.5.5 0 1 1-.554-.832L7.099 8 4.723 6.416a.5.5 0 1 1 .554-.832L7.5 7.066V4.5A.5.5 0 0 1 8 4Z" fill="currentColor"/></svg>`,
};
